import { Button, Flex, Heading, Image, Text } from "@chakra-ui/react";
import RouterLink from "../../components/router-link";

export default function NoteFoundView() {
  return (
    <Flex direction="column" p="2" gap="10" w="full" alignItems="center" h="full" pt="15vh">
      <Image src="/filler/error.png" h="140px" objectFit="contain" />
      <Heading fontSize="9xl" fontFamily="monospace">
        404
      </Heading>
      <Text fontSize="3xl" mb="10">
        Looks like that page does not exist
      </Text>
      <Button size="lg" colorScheme="primary" as={RouterLink} to="/">
        Return home
      </Button>
    </Flex>
  );
}
